import styled from 'styled-components'

import { ItemHeader } from '@/components/Style/Common'
import type { CompanyAddress as CompanyAddressT } from '@/types/Activity'

interface Props {
  address: CompanyAddressT | null
}

const CompanyAddressFields = styled.ul`
  list-style-type: none;
  padding: 0;
  text-wrap: wrap;
`

const CompanyAddress: React.FC<Props> = ({ address }) => {
  if (address === null) {
    return (
      <div>
        <ItemHeader>Company Address</ItemHeader>
        <p>Unknown</p>
      </div>
    )
  }
  const { name, line1, line2, city, postcode, country } = address

  return (
    <div>
      <ItemHeader>Company Address</ItemHeader>
      <CompanyAddressFields>
        <li>{name}</li>
        <li>{line1}</li>
        {line2 && <li>{line2}</li>}
        <li>{city}</li>
        <li>{postcode}</li>
        <li>{country}</li>
      </CompanyAddressFields>
    </div>
  )
}

export default CompanyAddress
